import React from "react";

import { Wrapper } from './style';

interface Props {
  children: React.ReactNode,
  minHeight: number,
  mobileMinHeight?: number,
}

const Section: React.FC<Props> = props => {
  return (
    <Wrapper
      minHeight={props.minHeight}
      mobileMinHeight={props.mobileMinHeight}
    >
      {props.children}
    </Wrapper>
  );
};

Section.defaultProps = {
  minHeight: 0,
};

export default Section;
